import React, { useEffect, useState } from 'react';
import { ViewProps } from 'react-native';
import Animated, {
  runOnJS,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';

export type FadeInOutProps = ViewProps & {
  visible: boolean;
  onEnd?: () => void;
};

export const FadeInOut: React.FC<FadeInOutProps> = ({
  children,
  visible,
  onEnd,
  style,
  ...props
}) => {
  const [shouldRender, toggle] = useState(false);
  const sv = useSharedValue(0);

  const transition = useAnimatedStyle(() => ({
    opacity: sv.value,
  }));

  const onAnimationEnd = () => {
    if (onEnd) onEnd();
  };

  useEffect(() => {
    if (visible && !shouldRender) {
      toggle(true);
      sv.value = withTiming(1);
    }

    if (!visible && shouldRender) {
      sv.value = withTiming(0, {}, () => runOnJS(onAnimationEnd)());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, shouldRender]);

  return !shouldRender ? null : (
    <Animated.View style={[style, transition]} {...props}>
      {children}
    </Animated.View>
  );
};
